import { Action, createReducer, on } from '@ngrx/store';
import * as StrategyActions from '../strategy.actions';
import * as AppRootActions from '@app/app.actions';
import * as ProfileActions from '@profile/profile.actions';

import { StrategyUIState } from '@shared/models/Strategy';

export const STRATEGY_UI_REDUCER_FEATURE_KEY = 'strategyUI';

export const initialState: StrategyUIState = {
  topicsButtonLoader: false,
  investmentButtonLoader: false,
  riskButtonLoader: false,
  generateStrategyLoader: false,
  generateProfileLoader: false,
  expandedCompanyId: null,
  riskToStrategyLoaderEve2: false,
  isSavingStrategyChangesEve2: false,
  strategyInfoLoaded: true
};

const strategyUIReducer = createReducer(
  initialState,
  // Full screen loader
  on(StrategyActions.updateRisk, (state, action) => ({
    ...state,
    generateStrategyLoader: action.continueToPortfolio,
    generateProfileLoader: action.continueToPortfolio,
    riskButtonLoader: !action.continueToPortfolio
  })),
  on(StrategyActions.getPortfolioCompanyListSuccess, (state) => ({
    ...state,
    generateStrategyLoader: false
  })),
  on(StrategyActions.closeGeneratePortfolioLoader, (state) => ({
    ...state,
    generateProfileLoader: false
  })),
  // Buttons
  on(StrategyActions.updateTopics, (state) => ({
    ...state,
    topicsButtonLoader: true
  })),
  on(StrategyActions.getTopicsDataSuccess, StrategyActions.getTopicsDataFail, StrategyActions.updateTopicsSuccess, (state) => ({
    ...state,
    topicsButtonLoader: false
  })),
  on(StrategyActions.updateInvestment, (state) => ({
    ...state,
    investmentButtonLoader: true
  })),
  on(StrategyActions.updateInvestmentSuccess, (state) => ({
    ...state,
    investmentButtonLoader: false
  })),
  on(StrategyActions.getCustomerInvestment, (state) => ({
    ...state,
    investmentButtonLoader: false
  })),
  on(StrategyActions.generateStrategy, StrategyActions.getLatestStrategyData, StrategyActions.generateStrategySuccess, (state) => ({
    ...state,
    riskButtonLoader: false
  })),
  on(StrategyActions.updateFailed, (state) => ({
    ...state,
    topicsButtonLoader: false,
    investmentButtonLoader: false,
    riskButtonLoader: false
  })),
  on(StrategyActions.updateRiskRecheck, (state) => ({
    ...state,
    riskButtonLoader: true
  })),
  on(AppRootActions.switchAccount, ProfileActions.logout, () => ({ ...initialState })),
  on(
    StrategyActions.setExpandedCompanyId,
    (state, action): StrategyUIState => ({
      ...state,
      expandedCompanyId: action.companyId
    })
  ),
  on(
    StrategyActions.showRiskToStrategyLoaderEve2,
    (state): StrategyUIState => ({
      ...state,
      riskToStrategyLoaderEve2: true
    })
  ),
  on(
    StrategyActions.hideRiskToStrategyLoaderEve2,
    (state): StrategyUIState => ({
      ...state,
      riskToStrategyLoaderEve2: false
    })
  ),
  on(
    StrategyActions.saveStrategyChangesEve2,
    (state): StrategyUIState => ({
      ...state,
      isSavingStrategyChangesEve2: true
    })
  ),
  on(
    StrategyActions.saveStrategyChangesSuccessEve2,
    StrategyActions.saveStrategyChangesFailEve2,
    StrategyActions.discardStrategyChangesEve2,
    (state): StrategyUIState => ({
      ...state,
      isSavingStrategyChangesEve2: false
    })
  ),
  on(
    StrategyActions.updateRiskEve2,
    StrategyActions.updateRiskRecheckEve2,
    (state): StrategyUIState => ({
      ...state,
      riskButtonLoader: true
    })
  ),
  on(
    StrategyActions.updateRiskSuccessEve2,
    StrategyActions.updateRiskFailedEve2,
    StrategyActions.updateRiskRecheckSuccessEve2,
    StrategyActions.updateRiskRecheckFailedEve2,
    StrategyActions.setTabIndex,
    (state): StrategyUIState => ({
      ...state,
      riskButtonLoader: false
    })
  ),

  on(
    StrategyActions.getStrategyInfo,
    (state): StrategyUIState => ({
      ...state,
      strategyInfoLoaded: false
    })
  ),
  on(
    StrategyActions.getStrategyInfoSuccess,
    (state): StrategyUIState => ({
      ...state,
      strategyInfoLoaded: true
    })
  )
);

export function reducer(state: StrategyUIState, action: Action): StrategyUIState {
  return strategyUIReducer(state, action);
}
